export default function () {
  return {
    loading: true,
    homePageData: null,
    products: {},
    hideComponent: {},
  }
}
